export function convertNullToUndefinedAndRemoveTypeName<T>(input?: T): T {
  if (input === null || input === undefined) {
    return undefined as T;
  }

  if (Array.isArray(input)) {
    return input.map((item) => convertNullToUndefinedAndRemoveTypeName(item)) as T;
  }

  if (typeof input === "object" && input !== null) {
    if (input instanceof Date) {
      return input;
    }
    const result = {} as T;
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key) && key !== "__typename") {
        result[key] = convertNullToUndefinedAndRemoveTypeName((input as T)[key]);
      }
    }
    return result as T;
  }

  return input;
}
